import { API } from "@/services"

export const API_KEY_ENDPOINTS = {
  create(data={}){
    return API.Axios.universal_ai.v1.request({
      url: `api-key`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `api-key`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.universal_ai.v1.request({
      url: `api-key/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `api-key/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `api-key/${id}`,
      method: 'PUT',
      data,
    })
  },
}